export enum UserPositionType {
  Normal = 'NORMAL',
  Contact = 'CONTACT',
}
